import script from "./ViewTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ViewTemplate.vue?vue&type=style&index=0&id=774a1af2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-774a1af2"]])

export default __exports__